const isMinorAmount = (value) => Number.isSafeInteger(value) && Number(value) >= 0;
export const resolvePaymentSummary = (amounts) => {
    if (isMinorAmount(amounts.amountSubtotalMinor) &&
        isMinorAmount(amounts.discountAmountMinor) &&
        isMinorAmount(amounts.taxAmountMinor) &&
        isMinorAmount(amounts.amountTotalMinor) &&
        (amounts.taxBehavior === 'exclusive' || amounts.taxBehavior === 'inclusive')) {
        return {
            source: 'stripe',
            amountSubtotalMinor: amounts.amountSubtotalMinor,
            discountAmountMinor: amounts.discountAmountMinor,
            taxAmountMinor: amounts.taxAmountMinor,
            amountTotalMinor: amounts.amountTotalMinor,
            taxBehavior: amounts.taxBehavior
        };
    }
    if (isMinorAmount(amounts.amountTotalMinor)) {
        return { source: 'generic', amountMinor: amounts.amountTotalMinor };
    }
    return {
        source: 'historical',
        amountMinor: isMinorAmount(amounts.amountMinor) ? amounts.amountMinor : 0
    };
};
